/**
 * Triggers the download of the resume PDF.
 */
export const downloadResume = () => {
  const link = document.createElement('a');
  link.href = '/HamzahsSoftwareEngineeringResume.pdf'; // Path to the file in the public folder
  link.download = 'HamzahsSoftwareEngineeringResume.pdf'; // Suggested filename for the user
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

function Resume() {
  // Keeping the component version in case it's still needed for automatic trigger elsewhere
  return null;
}

export default Resume;
